/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type InterviewAccessPurpose =
  (typeof InterviewAccessPurpose)[keyof typeof InterviewAccessPurpose];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewAccessPurpose = {
  application_entry: 'application_entry',
  interview: 'interview',
  practice: 'practice',
  staff_test: 'staff_test',
  recovery: 'recovery',
} as const;
